// divider constants for CardList and other table-like row layouts
export const DIVIDER = {
	width: "1px",
	opacity: 0.9,
};

/**
 * Build a vertical divider pseudo-element
 *
 * @param {string} color - dividerColor
 * @param {number} gap - ACTION_RAIL_GAP_Y
 * @param {"left"|"right"} side - which side the divider appears on
 */
export function verticalDivider(color, gap, side = "left") {
	return {
		content: '""',
		position: "absolute",
		[side]: 0,
		top: `${gap}px`,
		bottom: `${gap}px`,
		width: DIVIDER.width,
		backgroundColor: color,
		opacity: DIVIDER.opacity,
	};
}

/**
 * Build a horizontal divider for multi-row layouts
 */
export function horizontalDivider(color) {
	return {
		content: '""',
		position: "absolute",
		left: 0,
		right: 0,
		top: 0,
		height: DIVIDER.width,
		width: "100%",
		backgroundColor: color,
		opacity: DIVIDER.opacity,
	};
}
